import { SignOutButton } from "@/components/sign-out-button";
import type { LaunchAccount } from "@/lib/core/schemas/launch-hub";

const ACCESS_TIER_LABELS: Record<
  NonNullable<LaunchAccount["effectiveEntitlement"]>,
  string
> = {
  ADMIN: "Admin",
  INVITEE: "Invitee",
  PUBLIC: "Public",
};

function accessTierLabel(
  entitlement: LaunchAccount["effectiveEntitlement"]
): string {
  return entitlement ? ACCESS_TIER_LABELS[entitlement] : "No current access";
}

type AccountPanelProps = {
  account: LaunchAccount;
};

export function AccountPanel({ account }: AccountPanelProps) {
  const memberSince = account.memberSince
    ? account.memberSince.toLocaleDateString()
    : "—";

  return (
    <div className="flex max-w-md flex-col gap-6">
      <dl className="flex flex-col gap-4">
        <div>
          <dt className="text-muted-foreground text-xs uppercase tracking-wide">
            Email
          </dt>
          <dd className="text-sm">{account.email ?? "—"}</dd>
        </div>
        <div>
          <dt className="text-muted-foreground text-xs uppercase tracking-wide">
            Member since
          </dt>
          <dd className="text-sm">{memberSince}</dd>
        </div>
        <div>
          <dt className="text-muted-foreground text-xs uppercase tracking-wide">
            Access tier
          </dt>
          <dd className="text-sm">
            {accessTierLabel(account.effectiveEntitlement)}
          </dd>
        </div>
      </dl>
      <div>
        <SignOutButton />
      </div>
    </div>
  );
}
